import * as React from "react";
import TokenInputHybrid from "./TokenInputHybrid";
import type { TypeTokenInputProps } from "./TokenInputTypes";

/**
 * TokenInput component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 *
 * The standard React `ref` resolves to the root Container DOM node (required for
 * Radix UI's `asChild` pattern, used by seeds-react-menu's Popout, which expects
 * a DOM element for `.contains()` checks). The existing `innerRef` prop still
 * forwards to the underlying `<input>`.
 */
const TokenInput = React.forwardRef<HTMLDivElement, TypeTokenInputProps>(
  (props, ref) => <TokenInputHybrid {...props} ref={ref} />
);

TokenInput.displayName = "TokenInput";

export default TokenInput;
